import { Component, Host, h, Prop } from '@stencil/core';

export interface AhaBox extends HTMLAhaBoxElement {}

/**
 * Creates a box that contains some content.
 *
 * By default, this element gets an ARIA role of `region`. This can be
 * customized via the `role` property. `region` is recommended for cases where
 * you want to delineate a region of content and allow screen readers to "jump"
 * to it. More specific roles may be more appropriate; see the [region role
 * documentation](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Region_role).
 */
@Component({
  tag: 'aha-box',
  styleUrl: 'aha-box.css',
  shadow: true,
})
export class AhaBox {
  /**
   * Changes the style of the `aha-box`, useful when you want to nest it inside another `aha-box`
   */
  @Prop({ reflect: true }) nested: boolean = false;

  /**
   * A padding size for the box
   */
  @Prop({ reflect: true }) padding: 'none' | 'small' | 'medium' = 'medium';

  render() {
    return (
      <Host>
        <div id="main" class={`aha-box--padding-${this.padding}`}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
